import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";
import { getCookieValue, getStorage, isEmpty } from "../Utils/utils";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const getSavedIntsruments = createAsyncThunk(
  "savedInstruments/getSavedIntsruments",
  async ({ checkoutToken, shopperRef }, { rejectWithValue }) => {
    try {
      const sessionToken = getCookieValue('shopper_token') || localStorage.getItem("sessionToken");
      if (isEmpty(shopperRef)) return;
      const response = await axiosInstance.get(
        `${baseUrl}/checkout/sessions/${checkoutToken}/shoppers/${shopperRef}/recommended-instruments`,
        {
          headers: {
            Authorization: `Session ${sessionToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (err) {
      console.log('err', err);

      return rejectWithValue(err?.response);
    }
  }
);
export const deleteSavedInstruments = createAsyncThunk(
  "savedInstruments/deleteSavedInstruments",
  async ({ checkoutToken, shopperRef, instrumentRef, payload }, { rejectWithValue }) => {
    try {
      const sessionToken = getCookieValue('shopper_token') || localStorage.getItem("sessionToken");
      const response = await axiosInstance.delete(
        `${baseUrl}/checkout/sessions/${checkoutToken}/shoppers/${shopperRef}/instruments/${instrumentRef}`,
        {
          data: payload, // ✅ payload goes here
          headers: {
            Authorization: `Session ${sessionToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err?.response);
    }
  }
);

const initialState = {
  savedInstrumentsLoading: false,
  savedInstruments: [],
  selectedIntrument: null,
  deleteInstrumentsLoading: false,
  deletedInstrument: undefined,
  error: null,
};

export const savedInstrumentSlice = createSlice({
  name: "savedInstrument",
  initialState,
  reducers: {
    updateSelectedInstruments(state, action) {
      state.selectedIntrument = action.payload;
    },
    removeSelectedIntruments(state) {
      state.selectedIntrument = null;
    },
    removeDeletedInstrument(state) {
      state.deletedInstrument = undefined;
    },
    setSavedInstruments(state, action) {
      state.savedInstruments = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSavedIntsruments.pending, (state) => {
        state.savedInstrumentsLoading = true;
      })
      .addCase(getSavedIntsruments.fulfilled, (state, action) => {
        state.savedInstrumentsLoading = false;
        state.savedInstruments = action.payload;
      })
      .addCase(getSavedIntsruments.rejected, (state, action) => {
        state.savedInstrumentsLoading = false;
        state.error = action.payload?.data?.message;
      })

      .addCase(deleteSavedInstruments.pending, (state) => {
        state.deleteInstrumentsLoading = true;
      })
      .addCase(deleteSavedInstruments.fulfilled, (state, action) => {
        state.deleteInstrumentsLoading = false;
        state.deletedInstrument = action.payload;
      })
      .addCase(deleteSavedInstruments.rejected, (state, action) => {
        state.deleteInstrumentsLoading = false;
        state.error = action.payload?.data?.message;
        // state.savedInstruments = []
      });
  },
});

export const { updateSelectedInstruments, removeSelectedIntruments, removeDeletedInstrument, setSavedInstruments } =
  savedInstrumentSlice.actions;

export const selectSavedInstruments = (state) =>
  state.savedInstrument?.savedInstruments;
export const selectIsSavedInstrumentsLoding = (state) =>
  state.savedInstrument.savedInstrumentsLoading;
export const selectSelectedIntrument = (state) =>
  state.savedInstrument.selectedIntrument;

export default savedInstrumentSlice.reducer;


